import { render, staticRenderFns } from "./sKeywordDet.vue?vue&type=template&id=4ec5d190&scoped=true"
import script from "./sKeywordDet.vue?vue&type=script&lang=js"
export * from "./sKeywordDet.vue?vue&type=script&lang=js"
import style0 from "./sKeywordDet.vue?vue&type=style&index=0&id=4ec5d190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec5d190",
  null
  
)

export default component.exports